//@flow
import * as React from 'react';
import classnames from 'classnames';
import Link from 'react-toolbox/lib/link';
import defaultTheme from './Link.scss';
import { themr } from 'react-css-themr';

type Props = {
    theme?: Object,
    href: string,
    target?: string,
    theme: Object
};

const linkFactory = ({ LinkedComponent }) => {
    class LinkComponent extends React.Component<Props> {
        render() {
            const { theme, href, target, ...others } = this.props;
            return (
                <a href={href} target={target} className={theme.linkWrap}>
                    <LinkedComponent {...others} theme={theme} />
                </a>
            );
        }
    }
    return themr('LinkComponent', defaultTheme)(LinkComponent);
};

type CustomLinkProps = {
    onClick?: () => void,
    fieldId?: string | any,
    disabled: boolean
};

class CustomLink extends React.PureComponent<CustomLinkProps> {
    onClick = (...args) => {
        const { onClick, fieldId, disabled } = this.props;
        if (disabled) return;
        if (fieldId) {
            onClick && onClick(fieldId, ...args);
        } else {
            onClick && onClick(...args);
        }
    };
    render() {
        const {
            fieldId, // eslint-disable-line no-unused-vars
            theme,
            className,
            ...others
        } = this.props;
        return (
            <Link
                {...others}
                theme={theme}
                onClick={this.onClick}
                className={classnames(className, theme.link)}
            />
        );
    }
}
const ThemedCustomLink = themr('LinkComponent', defaultTheme)(CustomLink);
export { linkFactory, ThemedCustomLink as Link };
export default linkFactory;
